export default __webpack_public_path__ + "static/media/Rapid_Mood_Screener_Questionaire.817c5a5b.pdf";